import React, { Component } from 'react'

import { connect } from 'react-redux';
import {bindActionCreators} from "redux";
import './more-modal.css'
import './more-modal-320x720.css'

import {CCUtils, FirebaseUtils, CCBackLayout, SignIn, Profile,colors, Leaderboard, Help, Edition, About, CCMoreModalItem,strings, CCAppEventLogger,CCActions ,CCSideBarLayout} from "./../../cc-imports";

class MoreModal extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.initialState = {
            screen:undefined,
            moreModal:'true'
        }
        this.state = this.initialState;
        this._closeModal=this._closeModal.bind(this);
    }

    _closeModal() {
        this.props.actions.closeModal("More");
    }

    componentDidMount(){
        // if(this.props.userId && this.props.user.user.settings){
        //     this.setState(this.props.user.user.settings);
        // }
    }


    componentWillReceiveProps(nextProps) {

        if (nextProps.random != this.props.random) {
            this._updateGrouping(nextProps);
        }
    }

    _changeScreen(screen){
        this.setState({screen : screen});
    }

    render() {
        const user = this.props.user;

        const {screen} = this.state;
        return (
            <div className="flex-container cc-side-bar-layer" name={"More"} style={{flex:1, flexDirection: 'row'}}>
                <CCSideBarLayout  name={"More"}>
                    <div className="side-shadow more-modal-item">
                            <CCMoreModalItem onPress={()=>{CCAppEventLogger.logAppEvent('ProfileClicked',{}); if(user.id){this._changeScreen('profile')} else{this._changeScreen('signIn')} }} type={'user'}
                                             user={user}></CCMoreModalItem>
                            {
                                <CCMoreModalItem onPress={()=>{ CCAppEventLogger.logAppEvent('LeaderBoardClicked',{});  this._changeScreen('leaderboard')}} type={'content'}
                                                 title={strings('leaderboard')} name={"Leaderboard"}></CCMoreModalItem>
                            }

                            {
                                (user.id && false) &&
                                <CCMoreModalItem onPress={()=>{CCAppEventLogger.logAppEvent('ProfileClicked',{});this._changeScreen('profile');}} type={'content'}
                                                 title={strings('profile')} name={"Profile"}></CCMoreModalItem>
                            }
                            {
                                false &&
                                <CCMoreModalItem onPress={()=>{CCAppEventLogger.logAppEvent('EditionClicked',{params : { loggedIn: CCUtils.isLoggedIn(user)}});this._changeScreen('edition');}} type={'content'}
                                                 title={strings('edition')} name={"Edition"}></CCMoreModalItem>
                            }

                            {
                                false &&
                                <CCMoreModalItem onPress={()=>{CCAppEventLogger.logAppEvent('HelpClicked',{});this._changeScreen('help'); }}
                                                 type={'content'} title={strings('help')} name={"Help"}></CCMoreModalItem>
                            }

                            {
                                (user.id && false) &&
                                <CCMoreModalItem onPress={()=>{CCAppEventLogger.logAppEvent('SettingsClicked',{});this._changeScreen('settings');}}
                                                 type={'content'} title={strings('settings')} name={"Settings"}></CCMoreModalItem>
                            }
                            {
                                false &&
                                <CCMoreModalItem onPress={()=>{CCAppEventLogger.logAppEvent('AboutUsClicked',{});this._changeScreen('about');}}
                                                 type={'content'} title={strings('about')} name={"About"}></CCMoreModalItem>
                            }
                            {
                                (user.id!=null || user.id!=undefined && false) &&
                                <CCMoreModalItem onPress={()=>{FirebaseUtils.signOutFirebase(this.props.user.user);this._closeModal();CCAppEventLogger.logAppEvent('LogOutClicked',{});}} type={'content'}
                                                 title={strings('logout')} name={"Logout"}></CCMoreModalItem>
                            }
                    </div>
                    {
                        screen &&
                        <div className={"more-modal-item"}>
                            {
                                screen == 'about' &&
                                <About ></About>
                            }
                            {
                                screen == 'edition' &&
                                <Edition ></Edition>
                            }
                            {
                                screen == 'help' &&
                                <Help ></Help>
                            }
                            {
                                screen == 'more' &&
                                <Profile sponsorKey={"cricrush"} onBackPress={()=>{this._changeScreen('more')}} > </Profile>
                            }
                            {
                                screen == 'leaderboard' &&
                                <Leaderboard sponsorKey={"cricrush"} onBackPress={()=>{this._changeScreen('more')}} > </Leaderboard>
                            }
                            {
                                screen == 'profile' &&
                                <Profile ></Profile>
                            }
                            {
                                screen == 'signIn' &&
                                <SignIn onSignInSuccess={()=>{this._changeScreen('more')}} ></SignIn>
                            }
                        </div>
                    }
                </CCSideBarLayout>
            </div>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user : state.user.user,
        userId: state.user.user.id,
         screen: state.screen,
         moreModal:state.moreModal

    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(MoreModal);


// WEBPACK FOOTER //
// ./src/app/modals/MoreModal/MoreModal.js